import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  box: {
    flexDirection: "row",
    display: "flex",
    borderColor: "#c5c5c5",

    borderWidth: 2,
    borderRadius: 0,
    margin: 7,
  },
  button: {
    flexDirection: "row",
    display: "flex",
    borderRadius: 0,
    margin: 2,
    width: "100%",
    "&:hover": {
      backgroundColor: "rgba(171, 173, 35, 0.3)",
    },
  },

  checkedB: {
    alignItems: "flex-start",
    justifyContent: "center",
    borderColor: "#ABAD23",
    borderWidth: 10,
  },
  rippleVisible: {
    opacity: 0.5,
    animation: `$enter 350ms ${theme.transitions.easing.easeInOut}`,
  },
  "@keyframes enter": {
    "0%": {
      transform: "scale(0)",
      opacity: 0.1,
      backgroundColor: "rgba(171, 173, 35, 0.3)",
    },
    "100%": {
      transform: "scale(1)",
      opacity: 0.5,
      backgroundColor: "#ABAD23",
    },
  },
}));

export default useStyles;
